"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _excluded = ["classes", "className", "children", "preview"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** ****************************************************************************
 * Component
 **************************************************************************** */
var ChatToolbarMobile = function ChatToolbarMobile(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      children = _ref.children,
      preview = _ref.preview,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_Paper["default"], _extends({
    className: (0, _classnames["default"])(classes.root, className),
    square: true,
    elevation: 4
  }, props), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.colWrapper)
  }, preview && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.preview)
  }, preview), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.toolbar)
  }, children)));
};

ChatToolbarMobile.propTypes = {
  children: _propTypes["default"].node,
  classes: _propTypes["default"].object,
  className: _propTypes["default"].string,
  preview: _propTypes["default"].node
};
ChatToolbarMobile.defaultProps = {
  className: ''
};
/** ****************************************************************************
 * Styles
 **************************************************************************** */

var styles = function styles(theme) {
  return {
    root: {},
    colWrapper: {
      display: 'flex',
      flexDirection: 'column'
    },
    preview: {
      borderRadius: 0,
      display: 'flex',
      maxWidth: '100%',
      maxHeight: '40vh',
      position: 'relative'
    },
    toolbar: {
      borderRadius: 0,
      display: 'flex',
      alignItems: 'flex-end',
      flexShrink: 0,
      minHeight: 48,
      padding: '0 4px',
      zIndex: theme.zIndex.appBar
    }
  };
};

var _default = (0, _styles.withStyles)(styles)(ChatToolbarMobile);

exports["default"] = _default;